import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/solutions/product-development")({
  head: () => buildRouteHead("/es/solutions/product-development", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/soluciones/product-development", replace: true });
  },
});
